import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../api';
import { AppState } from '../../../../store/models/app-state';
import { ReduxDispatch } from '../../../../store/use-thunk-dispatch';

export const NEWS_POST_DELETED = 'NEWS_POST_DELETED';

export const newsPostDeleted = (id: number) => {
    return {
        type: NEWS_POST_DELETED,
        id,
    };
};

export const deleteNewsPost = (id: number) => {
    return async (dispatch: ReduxDispatch, _getState: () => AppState, { api }: { api: Api }) => {
        const response = await api.contentManagement.NewsPost.deleteNewsPost(id);

        if (response.success) {
            dispatch(newsPostDeleted(id));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
